import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Claim from 'edge/fnol/common/models/Claim';
import _ from 'lodash';

const fn = function (
    $scope, $state, $stateParams, $location, LoadSaveService, ModalService, wizardFlowService,
    fnolCompositeFlowDefn, ViewModelService, ClaimService, ServiceBoxInfoService, originState
) {
    const ctrl = Object.create(BaseCtrl);
    const parentWizardState = 'baseFnolWizard';
    const returnState = ($stateParams.accountNumber) ? ['accounts.detail.claims', {
        accountNumber: $stateParams.accountNumber
    }] : [originState.name, originState.params];

    ctrl.init = function () {
        const stepToStateMapping = {
            returnHome: () => returnState,
            confirmation: (model) => ['fnolconfirmation', {
                claimNumber: model.claimNumber.value,
                returnStateInfo: _.cloneDeep(returnState)
            }],
            error: (model) => ['contactAgent', {
                claimNumber: (model) ? model.claimNumber.value : null,
                hasError: true,
                returnStateInfo: _.cloneDeep(returnState)
            }]
        };

        //UCWAR-785
        $scope.linkEntryPolicyNumber = null;
        $scope.url = decodeURIComponent($location.url());
        console.log("FNOL entry URL :", $location.url());
        if (typeof $scope.url === 'string' && $scope.url.split('?').length > 1) {
            let params = $scope.url.split('?');
            let eachParamsArr = params[1].split('&');
            $scope.urlParams = {};
            if (eachParamsArr && eachParamsArr.length) {
                eachParamsArr.map(param => {
                    let keyValuePair = param.split('=')
                    let key = keyValuePair[0];
                    let value = keyValuePair[1];
                    $scope.urlParams[key] = value;
                })
            }
            $scope.linkEntryPolicyNumber = $scope.urlParams.policyNumber;
            $scope.serviceQuoteId = $scope.urlParams.serviceQuoteId;
            $scope.claimNumber = $scope.urlParams.claimNumber;
            $scope.claimStatus = $scope.urlParams.claimStatus;
        }

        const flowfactory = wizardFlowService(fnolCompositeFlowDefn, parentWizardState, stepToStateMapping);

        if ($stateParams.claimNumber || ($scope.claimNumber && $scope.claimStatus == 'draft')) { // resume draft claim
            if ($scope.serviceQuoteId != undefined) {
                const operation = ClaimService.getServiceQuoteInfo($scope.serviceQuoteId);
                operation.then((result) => {
                    if (result != undefined) {
                        ServiceBoxInfoService.serviceQuoteTempData = result;
                        ServiceBoxInfoService.serviceQuoteTempData.id = $scope.serviceQuoteId;
                    }
                }).catch((error) => {
                    ModalService.showError('gateway.views.modal.Error', 'quoteandbind.common.flow.error.An error has occurred...');
                });
            } else {
                ServiceBoxInfoService.serviceQuoteTempData = undefined;
            }
            const claimLoadPromise = LoadSaveService.getClaim($stateParams.claimNumber ? $stateParams.claimNumber : $scope.claimNumber);
            $scope.claimLoadPromise = claimLoadPromise;

            claimLoadPromise.then((draftClaim) => {
                const claimModel = ViewModelService.create(new Claim(draftClaim), 'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO');
                flowfactory.resume(claimModel, {
                    accountNumber: $stateParams.accountNumber,
                    policyNumber: $stateParams.policyNumber
                });

            }).catch(() => {
                const errorPromise = ModalService.showError(
                    'fnol.common.controllers.FnolEntryCtrl.Error retrieving claim',
                    'fnol.common.controllers.FnolEntryCtrl.An error occurred attempting to retrieve claim.'
                ).result;
                errorPromise.then(() => {
                    // return the originating state
                    $state.go(originState.name, originState.params);
                });
            });

        } else {

            const claimModel = ViewModelService.create(new Claim(), 'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO');

            if ($scope.serviceQuoteId != undefined) {
                const operation = ClaimService.getServiceQuoteInfo($scope.serviceQuoteId);
                operation.then((result) => {
                    if (result != undefined) {
                        ServiceBoxInfoService.serviceQuoteTempData = result;
                        ServiceBoxInfoService.serviceQuoteTempData.id = $scope.serviceQuoteId;
                        console.log("New service box claim: policy Number : ", result.policyNumber);
                        flowfactory.start(claimModel, {
                            accountNumber: $stateParams.accountNumber,
                            policyNumber: result.policyNumber
                        });
                    }
                }).catch((error) => {
                    ModalService.showError('gateway.views.modal.Error', 'quoteandbind.common.flow.error.An error has occurred...');
                });
            } else {
                ServiceBoxInfoService.serviceQuoteTempData = undefined;
            }
            if ($scope.serviceQuoteId == undefined) {
                flowfactory.start(claimModel, {
                    accountNumber: $stateParams.accountNumber,
                    policyNumber: $stateParams.policyNumber ? $stateParams.policyNumber : $scope.linkEntryPolicyNumber
                });
            }
            if ($scope.urlParams == undefined || $scope.urlParams.serviceQuoteId == undefined) {
                flowfactory.start(claimModel, {
                    accountNumber: $stateParams.accountNumber,
                    policyNumber: $stateParams.policyNumber ? $stateParams.policyNumber : $scope.linkEntryPolicyNumber
                });
            }
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', '$location', 'fnol.LoadSaveService', 'ModalService', 'WizardFlowService', 'fnol.CompositeFlowDefn', 'ViewModelService', 'claim.ClaimService', 'ServiceBoxInfoService', 'originState'];

export default fn;
